import { HStack, Checkbox, Text } from '@chakra-ui/react';
import { useCompanyForm } from '../../hooks/useCompanyForm';
import { getBillingFieldPaths, getBillingSettings } from '../../constants';
import { toast } from 'react-toastify';

const billingToggles = [
    {
        key: 'leadInProrata',
        label: 'Lead In Pro Rata',
        sx: { paddingTop: '7px' },
    },
    {
        key: 'processBilling',
        label: 'Process Billing',
    },
    {
        key: 'omitNumberBlocks',
        label: 'Omit Number Blocks',
    },
    {
        key: 'alwaysBillGlobalNumberBlocks',
        label: 'Always Bill Global Number Blocks',
        modes: ['Wholesaler'],
    },
];

const BlankBillingToggles = () => {
    const { formData, updateFormData, mode } = useCompanyForm();
    const billingFieldPaths = getBillingFieldPaths(mode);
    const billingSettings = getBillingSettings(formData, mode);
    const visibleToggles = billingToggles.filter(
        (toggle) => !toggle.modes || toggle.modes.includes(mode),
    );

    return (
        <HStack
            spacing={4}
            width="100%"
            alignItems="center"
            justify="right"
            paddingRight="70px"
            py={2}>
            {visibleToggles.map((toggle) => (
                <Checkbox
                    key={toggle.key}
                    isChecked={billingSettings?.[toggle.key] || false}
                    onChange={(e) => {
                        updateFormData(
                            `${billingFieldPaths.SETTINGS}.${toggle.key}`,
                            e.target.checked,
                        );

                        if (
                            !billingSettings?.omitNumberBlocks &&
                            toggle.key === 'omitNumberBlocks' &&
                            e.target.checked
                        ) {
                            toast.info(
                                'Stop generating invoices (only for this entity)',
                                {
                                    toastId:
                                        new Date().getTime().toString() +
                                        Math.random(),
                                },
                            );
                        }
                    }}
                    display="flex"
                    alignItems="center"
                    height="40px"
                    sx={{ verticalAlign: 'middle', ...toggle.sx }}>
                    <Text
                        fontSize="13px"
                        lineHeight="40px"
                        height="40px"
                        display="flex"
                        alignItems="center">
                        {toggle.label}
                    </Text>
                </Checkbox>
            ))}
        </HStack>
    );
};

export default BlankBillingToggles;
